import {CardModel, EvaluationMark, PreloadBufferItem, TopicModel} from "../../interfaces/models/CardModel";

export const CardSourceSymbol = Symbol.for('CardSourceSymbol');

export interface ICardSourceAdapter {
    getCardById(cardId: number): Promise<CardModel>;
    getCard(courseId: number): Promise<CardModel>;
    getTopic(courseId: number, topicId: number): Promise<TopicModel>;
    preload(courseId: number): Promise<PreloadBufferItem>;
    skip(courseId: number, id: number, nextId: number): Promise<any>;
    evaluate(id: number, courseId: number, nextId: number, mark: EvaluationMark, update: boolean, log: string): Promise<any>;
}
